import { FC } from "react";
import {TimeIcon} from "src/assets/Icons";
import { Trans } from "react-i18next";
import { LayoverType } from "src/Modules/Flights/constants";
import { explode, formatTimeFromUnit } from "src/utility";

const FlightLayover: FC<{ layover: LayoverType }> = ({ layover }) => {
  if (!layover) return;
  const { city, airport, durationMinutes } = explode(layover, {});
  const parsedDuration = formatTimeFromUnit(durationMinutes, "m");
  const location = airport ? `${city} (${airport})` : city;
  return (
    <div className="bg-background-minimal border-border-warning text-font-default flex w-full items-center gap-2 rounded-s-xs border-s-2 px-2 py-2.5 text-xs font-medium">
      <TimeIcon className="text-icon-warning size-4 shrink-0" />
      <span>
        <Trans
          i18nKey="Flights.details.flightPath.layoverIn"
          values={{ duration: parsedDuration, city: location }}
          components={[<span className="font-semibold" />]}
        />
      </span>
    </div>
  );
};

export default FlightLayover;
